import { Dispatch, createContext } from "react";

export const SelectedShippingContext = createContext<number | null>(null);
export const SelectedShippingDispatchContext = createContext<
  Dispatch<{ type: "setSelectedShipping"; payload: number | null }>
>(() => { });

export const selectedShippingReducer = (
  state: number | null,
  action: { type: "setSelectedShipping"; payload: number | null }
) => {
  if (action.type === "setSelectedShipping") {
    return action.payload
  } else {
    return state
  }
};
